import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { contentEngineService } from "./content-engine-v2/content-engine.service";

const Logout = () => {
  const navigate = useNavigate();
  useEffect(() => {
    localStorage.removeItem("TOKEN");
    contentEngineService.clearCache();
    navigate("/login");
  }, []);
  return <p>Logont</p>;
};

export default Logout;
